import React from 'react';
import { useFormulaExecute } from '../../../utils/hooks';
import useQueryTypeFromLocation from '../../../utils/routes/useQueryTypeFromLocation';
import { assertNotNil } from '../../../utils/types';
import ExecuteReportAction from './ExecuteReportAction';
import { IS_SCREENSHOT_MODE } from '../../../config/constants';

const ExecuteReport = () => {
  const queryType = useQueryTypeFromLocation();
  assertNotNil(queryType);

  const [executeReport, isValidFormula, isMutationLoading] =
    useFormulaExecute(queryType);

  if (IS_SCREENSHOT_MODE) {
    return null;
  }

  return (
    <ExecuteReportAction
      onClick={executeReport}
      loading={isMutationLoading}
      isGreyedOut={!isValidFormula}
    />
  );
};

export default ExecuteReport;
